import { EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Image } from "antd";
import { useEffect, useState } from "react";
import http from "../../../../../../services/http";

const RenderDocument = ({ id, name, type }) => {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    type?.startsWith("image/") && loadImage(id);
  }, [id]);

  const loadImage = async (id) => {
    const url = await fetchDocument(id);
    setImage(url);
  };

  const baixarAnexo = async (id, name) => {
    const url = await fetchDocument(id);
    let a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.click();
  };

  const fetchDocument = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/problemas_anexos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const url = window.URL.createObjectURL(api?.response?.data);
      setLoading(false);
      return url;
    } else {
      setLoading(false);
      return null;
    }
  };

  return (
    <>
      <Image
        style={{ display: "none" }}
        src={image ?? ""}
        preview={{
          src: image ?? "",
          visible: visible,
          onVisibleChange: (value) => {
            setVisible(value);
          },
        }}
      />

      <Button
        type="text"
        loading={loading}
        onClick={() => (type.startsWith("image/") ? setVisible(true) : baixarAnexo(id, name))}
        icon={type.startsWith("image/") ? <EyeOutlined /> : <DownloadOutlined />}
      />
    </>
  );
};

export { RenderDocument };
